import { render, staticRenderFns } from "./CommentTile.vue?vue&type=template&id=1c64ee5a&scoped=true"
import script from "./CommentTile.vue?vue&type=script&lang=js"
export * from "./CommentTile.vue?vue&type=script&lang=js"
import style0 from "./CommentTile.vue?vue&type=style&index=0&id=1c64ee5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c64ee5a",
  null
  
)

export default component.exports